
export const addScenarioGroupFromAPI = ( scenarioGroup ) => {
    return {
        type: "ADD_SCENARIO_GROUP_FROM_API",
        scenarioGroup: scenarioGroup.data,
        pages: scenarioGroup.pages,
        currentPage: scenarioGroup.current_page,
        allScenarioGroup: scenarioGroup.all_details
    }
}

export const editScenarioGroupData = ( scenarioGroup ) => {
    return {
        type: "EDIT_SCENARIO_GROUP",
        scenarioGroup
    }
}

export const deleteScenarioGroupData = ( { scenarioGroup } ) => {
    return {
        type: "DELETE_SCENARIO_GROUP",
        scenarioGroup: scenarioGroup.data
    }
}
